const INITIAL_STATE = {
  error: null,
  loading: null,
  data:[]
};

const UpdateEmailSales = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "UPDATE_EMAIL_SALES_REQUEST":
      return { loading: true, error: false };
    case "UPDATE_EMAIL_SALES_ERROR":
      return { loading: false, error: true };
    case "UPDATE_EMAIL_SALES_SUCCESS":
      return { loading: false, error: false };
    default:
      return state;
  }
};

export default UpdateEmailSales;
